



















































import { Component, Vue, Prop } from 'vue-property-decorator'
import PhotoHeader from '../components/organization/PhotoHeader.vue'
import Main from '../components/organization/Main.vue'
import MiniCourse from '../components/miniCourse/index.vue'
import SectionCourse from '../components/organization/SectionCourse.vue'

import { Exposicao_Cursos } from '@/storage/programacao/exposicao'

@Component({
  components: {
    PhotoHeader,
    Main,
    MiniCourse
  }
})
export default class Exposicoes extends Vue {
  private all_exposicoes: any

  private title = 'Exposições'
  private background = 'assets/img/slider/expo_design.jpeg'

  constructor() {
    super()

    this.all_exposicoes = Exposicao_Cursos
  }
}
